import {
  UPDATE_PARAMS,
  RESET_PARAMS,
  GET_FILTERS,
  FILTERS_RECEIVED,
  REMOVE_PARAM,
  DOWNLOAD_OFFERS,
} from './constants';

/**
 *
 * @returns {{type: string}}
 */
export function getFilters() {
  return {
    type: GET_FILTERS,
  };
}

/**
 *
 * @param filters
 * @returns {{type: string, params: *}}
 */
export function filtersLoaded(filters) {
  return {
    type: FILTERS_RECEIVED,
    filters,
  };
}

/**
 *
 * @param param
 * @returns {{type: string, param: {}}}
 */
export function updateParam(param) {
  return {
    type: UPDATE_PARAMS,
    param,
  };
}

/**
 *
 * @returns {{type: string}}
 */
export function resetParams() {
  return {
    type: RESET_PARAMS,
  };
}

/**
 *
 * @param paramName
 * @returns {{paramName: *, type: string}}
 */
export function removeParam(paramName) {
  return {
    type: REMOVE_PARAM,
    paramName,
  };
}

/**
 */
export function downloadOffers() {
  return {
    type: DOWNLOAD_OFFERS,
  };
}

